import styled, { css } from "styled-components"

import { formatPriceByLocale } from "utils/utils"

import Button from "components/presenters/common/form/Button"

export default function PurchaseBtn({
  lowestPrice,
  lowestChallengePrice,
  onBtnClick,
  isAlreadyParticipated,
}) {
  return (
    <PurchaseBtnBlock>
      {isAlreadyParticipated ? (
        <SingleBtnBlock>
          <SinglePurchaseBtn data-type={"normal"} onClick={onBtnClick} fullWidth>
            <Price>{`${formatPriceByLocale("ko", lowestPrice)}원`}</Price>
            <BtnText>인증없이 구매하기</BtnText>
          </SinglePurchaseBtn>
        </SingleBtnBlock>
      ) : (
        <PurchaseBtnList>
          <NomalPurChaseBtn data-type={"normal"} onClick={onBtnClick}>
            <Price>{`${formatPriceByLocale("ko", lowestPrice)}원`}</Price>
            <BtnText>인증없이 구매하기</BtnText>
          </NomalPurChaseBtn>
          <ChallengePurChaseBtn data-type={"challenge"} onClick={onBtnClick} fullWidth>
            <Price>{`${formatPriceByLocale("ko", lowestChallengePrice)}원`}</Price>
            <BtnText>인증 성공하고, 환급받기</BtnText>
          </ChallengePurChaseBtn>
        </PurchaseBtnList>
      )}
    </PurchaseBtnBlock>
  )
}

const PurchaseBtnBlock = styled.div`
  flex: 0 1 auto;
  width: 100%;
`

const SingleBtnBlock = styled.div`
  padding-top: calc(100vw * (13 / 375));
  padding-right: calc(100vw * (20 / 375));
  padding-left: calc(100vw * (20 / 375));
`

const PurchaseBtnList = styled.div`
  display: flex;
  padding-top: calc(100vw * (13 / 375));
  padding-right: calc(100vw * (11 / 375));
  padding-left: calc(100vw * (11 / 375));
`

const purchaseBtnStyle = css`
  padding: calc(100vw * (13 / 375)) 0;
`

const NomalPurChaseBtn = styled(Button)`
  ${purchaseBtnStyle};
  margin-right: calc(100vw * (11 / 375));
  background-color: #f7f7f7;
  width: calc(100vw * (136 / 375));
`

const ChallengePurChaseBtn = styled(Button)`
  ${purchaseBtnStyle};
  width: calc(100vw * (206 / 375));
`

const SinglePurchaseBtn = styled(Button)`
  ${purchaseBtnStyle};
`

const Price = styled.p`
  font-size: calc(100vw * (16 / 375));
  font-weight: 700;
  margin-bottom: calc(100vw * (6 / 375));
  color: #121212;
`

const BtnText = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (14.4 / 375));
  color: #4e4e4e;
`
